<template>
  <div class="bread-wrapper">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">控制面板</el-breadcrumb-item>
      <el-breadcrumb-item>路由管理</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb'
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/authority/components/Breadcrumb.vue